import AxiosCustom from "common/components/apiConfig";
import {
	handleNotificationAlertCatch,
	handleNotificationAlertTrySelect,
} from "common/method/handleNotificationAlert";
import { put, takeLatest } from "redux-saga/effects";

// import { handleNotificationAlertTrySelect } from './../../common/method/handleNotificationAlert/index';

export const actionTypes = {
	getCaptcha: "getCaptcha [Action]",
	getCaptchaLoading: "getCaptchaLoading [Action]",
	getCaptchaAsync: "getCaptchaAsync [Action]",
};
const inistiaState = {
	data: [],
	loading: false,
	total: 0,
};

export const get_captcha_reducer = (
	state = inistiaState,
	{ type, payload },
) => {
	switch (type) {
		case actionTypes.getCaptcha:
			return {
				...state,
				data: payload?.results,
				total: payload?.total,
			};
		case actionTypes.getCaptchaLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

function* handleWorker({ payload }) {
	yield put({ type: actionTypes.getCaptchaLoading, payload: true });

	let config = {
		url: "login",
	};

	let data = {
		table: "clubmember",
		method_type: "get_captcha",
		data: payload?.data ? payload.data : {},
	};

	try {
		let res = yield AxiosCustom(config, data);
		let isOk = handleNotificationAlertTrySelect(res);
		if (!isOk) {
			return;
		}
		yield put({
			type: actionTypes.getCaptcha,
			payload: res?.data?.response?.data,
		});
	} catch {
		handleNotificationAlertCatch();
	} finally {
		yield put({ type: actionTypes.getCaptchaLoading, payload: false });
	}
}

export function* getCaptcha() {
	yield takeLatest(actionTypes.getCaptchaAsync, handleWorker);
}
